module.exports = __webpack_public_path__ + "media/images/intellias-35ad65d62fb329bad515187ea6dfba7d.jpeg";